<template>
  <div class="empty-search-state">
    <icon-empty v-if="isSearchPage" />

    <ais-search-box>
      <template #default="{ currentRefinement }">
        <p
          class="text-heading-l empty-search-state__no-results"
          v-text="$string('predictive_search.no_results', {
            replace: { query: currentRefinement }
          })"
        />
      </template>
    </ais-search-box>

    <p
      class="text-body-s-regular empty-search-state__instruction"
      v-text="$string('predictive_search.no_results_instruction')"
    />

    <btn
      v-if="isSearchPage"
      class="empty-search-state__cta"
      modifiers="primary"
      :label="$string('search.empty_state_cta')"
      :url="$variable('routes.root')"
    />
  </div>
</template>

<script>

/**
 * Vue: Empty search state (empty-search-state)
 * -----------------------------------------------------------------------------
 * Empty search state, used in search page and predictive search modal.
 *
 */
import { AisSearchBox } from 'vue-instantsearch/vue3/es'
import Btn from '~global/btn/btn'
import IconEmpty from '~icons/misc/empty.svg'

export default {
  name: 'EmptySearchState',

  components: {
    AisSearchBox,
    Btn,
    IconEmpty,
  },

  props: {
    isSearchPage: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss">
@import './empty-search-state';
</style>
